// globals.js
export let globalShopName = 'defaultShopName';

export const setGlobalShopName = (name) => {
  globalShopName = name;
};